import { withInstall } from '@lit-element/utils'
import Segmented from './src/segmented.vue'

export const LtSegmented = withInstall(Segmented)
export default LtSegmented

export * from './src/segmented'
